import script from "./remove-channel-pulse-confirm.vue?vue&type=script&setup=true&lang=js"
export * from "./remove-channel-pulse-confirm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__